import Table from "/src/components/table";
import botService from "../../services/botService";
import { formatDate } from "/src/utils/formatDate";
import { useNavigate } from "react-router-dom";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import capitalizeFirstLetter from "/src/utils/capitalizeFirstLetter";

function BotSharedTable() {
    const navigate = useNavigate();
    const toast = useToastDispatchContext();

    const { getBots, deleteBot, getBotsShared } = botService;
    const cells = [
        {
            column: "Company",
            name: "company",
            sort: true,
            show: (company) => <img srcSet={company.logo} title={company.name} alt=""></img>,
        },
        {
            column: "Name",
            name: "name",
            sort: true,
            show: (value) => <span style={{ fontWeight: 700 }}>{value}</span>,
        },
        {
            column: "Language",
            name: "language.slug",
            show: (value) => <span className={"flag-icon flag-icon-" + value.toLowerCase()} />,
        },
        {
            column: "Description",
            name: "description",
            show: (value) => capitalizeFirstLetter(value),
        },

        {
            column: "Updated",
            name: "updated_at",
            sort: true,
            show: (value) => formatDate(value),
        },
    ];

    const actions = [
        //{className : "fas fa-cog action-button edit_action", style : {}, onClick : onClickUpdate},
        //{className : "fas fa-edit action-button profil_action", style :{}, onClick : onClickRedirect}, // the padding for this icon is weird...
        //{className : "fas fa-trash action-button delete_action", style : {}, onClick : onClickDelete},
    ];

    const buttons = [
        //{icon : 'fas fa-plus' , onClick : onClickAdd}
    ];
    const filters = [{ type: "input", placeholder: "content", name: "name" }];

    const filtersAscending = ["name"];

    return (
        <Table
            name="bot"
            cells={cells}
            api={getBotsShared}
            actions={actions}
            buttons={buttons}
            filters={filters}
            filtersAscending={filtersAscending}></Table>
    );
}

export default BotSharedTable;
